const SelectedTab = require('./SelectedTab');

module.exports = SelectedTab;
